/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_ra as ra,
} from "../../runtime/index.jsx";
export function Componente_vA_118_65(e) {
  let t = (0, ReactCompiler.c)(8),
    { persona: n, onQuitar: r } = e,
    i;
  t[0] === n.nombre
    ? (i = t[1])
    : ((i = (
        <span
          className={`flex-1 truncate text-(--text-h)`}
          children={n.nombre}
        />
      )),
      (t[0] = n.nombre),
      (t[1] = i));
  let a;
  t[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((a = (0, JSXRuntime.jsx)(ra, {
        className: `h-4 w-4`,
      })),
      (t[2] = a))
    : (a = t[2]);
  let o;
  t[3] === r
    ? (o = t[4])
    : ((o = (
        <button
          type={`button`}
          onClick={r}
          aria-label={`Quitar`}
          className={`p-2 text-(--text) hover:text-(--error)`}
          children={a}
        />
      )),
      (t[3] = r),
      (t[4] = o));
  let s;
  return (
    t[5] !== i || t[6] !== o
      ? ((s = (
          <div
            className={`flex items-center gap-2 rounded-2xl border border-(--border) px-3 py-2`}
            children={[i, o]}
          />
        )),
        (t[5] = i),
        (t[6] = o),
        (t[7] = s))
      : (s = t[7]),
    s
  );
}
